"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AsyncExportTable = _interopRequireDefault(require("./AsyncExportTable.vue"));
var _constants = require("./constants");
var _default = exports.default = {
  name: 'YsAsyncExport',
  components: {
    YsAsyncExportTable: _AsyncExportTable.default
  },
  props: {
    exportFn: {
      type: Function
    },
    columns: {
      type: Array,
      required: false,
      default: () => _constants.EXPORT_DEFAULT_COLUMNS
    },
    bizType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      visible: false,
      loading: false
    };
  },
  methods: {
    refresh() {
      this.$refs.tableRef.refresh();
    },
    async handleExport() {
      try {
        this.loading = true;
        await this.$refs.tableRef.handleExport();
      } finally {
        this.loading = false;
      }
    },
    async handleOpen() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    }
  }
};